import { translate } from '@teamleader/i18n';
import React from 'react';

import * as styles from './styles.css';
import Box from '../../../Components/UI/Box';
import Button from '../../../Components/UI/Button';
import Lottie from '../../../Components/UI/Lottie';
import { WithTooltip } from '../../../Components/UI/Tooltip';
import error from '../../../Svg/Lottie/error.json';

interface ErrorMessageProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  onRetry?: () => void;
  allowRetry?: boolean;
  retryLabel?: string;
}

const ButtonWithTooltip = WithTooltip(Button);

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  icon,
  title,
  description,
  onRetry,
  retryLabel,
  allowRetry = true,
}) => {
  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      className={styles['message']}
      paddingHorizontal={4}
    >
      <Lottie animationData={error} className={styles['message-icon']}>
        {icon}
      </Lottie>
      <h2 className={styles['message-title']}>{title}</h2>
      <p className={styles['message-description']}>{description}</p>
      {allowRetry && (
        <ButtonWithTooltip
          type={onRetry ? 'button' : 'submit'}
          onClick={onRetry}
          label={retryLabel}
          level="primary"
          marginTop={3}
        >
          {translate('actions.retry')}
        </ButtonWithTooltip>
      )}
    </Box>
  );
};

export default ErrorMessage;
